import React, { ReactNode } from 'react';

import CheckboxImage from '@images/checkbox.svg';
interface Props {
  children: ReactNode;
  id: string;
  toggleCheckbox: () => void;
  checked: boolean;
  enabled?: boolean;
}

export default function Checkbox({
  children,
  id,
  toggleCheckbox,
  checked,
  enabled,
}: Props): JSX.Element {
  return (
    <div className="checkbox-container">
      <label className="checkbox-label checkbox" htmlFor={id}>
        <input
          id={id}
          type="checkbox"
          className="checkbox-input"
          checked={checked}
          onChange={toggleCheckbox}
          disabled={!enabled}
        />
        <span className="checkbox-checkmark">{checked ? <CheckboxImage /> : null}</span>
        {children}
      </label>
    </div>
  );
}
